import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { PersonalCalendarRead } from '@ragu-components/ord-types';

export const personalCalendarsResource: OrdResourceProps = {
  key: `me/${Resources.calendars}`,
  name: `me/${Resources.calendars}`,
  options: {},
  recordRepresentation: (record: PersonalCalendarRead): string => record.title,
};
